'use client'

import { datadogRum } from '@datadog/browser-rum'
// import { environment } from 'constants/environment'
import packageJson from '../package.json'

const version = `${packageJson.version}-${process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT}`

const botPattern =
  '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)'

const regex = new RegExp(botPattern, 'i')

const initializeDatadog = () => {
  if (typeof window !== 'undefined') {
    return !regex.test(window.navigator.userAgent) // Don't initialize Datadog RUM for bots - see https://docs.datadoghq.com/real_user_monitoring/guide/identify-bots-in-the-ui/#filter-out-bot-sessions-on-intake
  }

  return false
}

if (process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID && initializeDatadog()) {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: 'pub81027c640fa9019d29f1ae581d64e640',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'theexpert.com',
    env: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'development',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    version,
    // proxy: `${environment.APP_URL}/api/dd-proxy`,
    allowedTracingUrls: [
      {
        match: 'https://api.theexpert.com/',
        propagatorTypes: ['tracecontext'],
      },
      {
        match: 'https://cms.theexpert.com/',
        propagatorTypes: ['tracecontext'],
      },
      {
        match: 'https://api.staging.theexpert.com/',
        propagatorTypes: ['tracecontext'],
      },
      {
        match: 'https://staging.cms.theexpert.com/',
        propagatorTypes: ['tracecontext'],
      },
      {
        match: 'http://localhost:3001/',
        propagatorTypes: ['tracecontext'],
      },
      {
        match: 'http://localhost:1337/',
        propagatorTypes: ['tracecontext'],
      },
    ],
  })
}

export const DatadogInit = () =>
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  null
